import { memo } from "react";
import { C } from "../../match/shared/matchTokens";
import { useSyncStatus } from "../hooks/useSyncStatus";

const TONE_DOT = {
  success: C.gr,
  warn: C.acc,
  danger: C.loss,
  muted: C.txtD,
  neutral: C.txtM,
};

/**
 * Compact sync indicator for match workspace and TV mode.
 */
function SyncIndicator({ className = "" }) {
  const { displayPhase, minimal, label, hint, tone } = useSyncStatus();

  const dotColor = TONE_DOT[tone] || TONE_DOT.neutral;
  const ariaLabel = hint ? `${label}. ${hint}` : label;

  return (
    <div
      className={`ss-sync-indicator${minimal ? " ss-sync-minimal" : ""}${className ? ` ${className}` : ""}`}
      role="status"
      aria-live="polite"
      aria-label={ariaLabel}
      title={ariaLabel}
    >
      <span
        className="ss-sync-dot"
        style={{ backgroundColor: dotColor }}
        aria-hidden
      />
      {!minimal && (
        <span className="ss-sync-text">
          {displayPhase === "synced" && (
            <span className="ss-sync-check" aria-hidden>
              ✓{" "}
            </span>
          )}
          {label}
          {hint ? (
            <span className="ss-sync-hint">
              <br />
              {hint}
            </span>
          ) : null}
        </span>
      )}
    </div>
  );
}

export default memo(SyncIndicator);
